





import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class InvoiceFormInput extends Vue {
  @Prop()
  value!: string;

  @Prop({ default: () => [] })
  rules!: Function[];

  @Prop()
  isValid!: boolean;

  @Prop()
  type?: "textarea" | string;

  mounted() {
    this.adjustTextareaHeight();
    this.validate({ target: this.$refs.input });
  }

  validate(event: any) {
    const value = event.target.value as string;

    for (const rule of this.rules) {
      if (typeof rule(value) === "string") {
        this.$emit("update:isValid", false);
        event.target.style.border = "2px solid";
        event.target.style.borderColor = "red";
        event.target.style.borderRadius = "5px";
        return;
      }
    }

    event.target.style.border = null;
    event.target.style.borderColor = null;
    event.target.style.borderRadius = null;
    this.$emit("update:isValid", true);
  }

  onInput(event: any) {
    const value = event.target.value as string;
    this.$emit("input", value);
    this.adjustTextareaHeight();

    this.validate(event);
  }

  adjustTextareaHeight() {
    if (this.type !== "textarea") {
      return;
    }

    const textarea = this.$refs.input as HTMLTextAreaElement;
    if (textarea) {
      textarea.style.height = "auto"; // Reset height to auto to calculate the new height

      let scrollHeight = textarea.scrollHeight;
      if (scrollHeight < 40) {
        scrollHeight = 40;
      }
      textarea.style.height = `${scrollHeight}px`; // Set height based on scrollHeight}
    }
  }
}
